import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {ItemRequest} from '@store/item-requests/item-requests.types';
import {ItemRequestsSelectors} from '@store/item-requests/item-requests.selectors';

@Component({
  selector: 'px-item-request-author-column',
  host: {
    class: 'text-wrap',
  },
  template: `
    <p>{{ selectors.calculatedAuthorFor(itemRequest) | select }}</p>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectPipe]
})
export class ItemRequestAuthorColumnComponent {
  @Input({required: true}) public itemRequest: ItemRequest;
  public readonly selectors = ItemRequestsSelectors.Stateless;
}
